export default {
  v3: () => import("/Volumes/Tian_SanDisk/DEV/hm-cloud/frontend/layouts/v3.vue").then(m => m.default || m)
}